<style lang="stylus" scoped>
.describe {
  color: #fff;

  .title {
    font-size: 36px;
    text-align: center;
  }

  .total-num {
    font-size: 75px;
    margin: 30px auto;
    display: flex;
    justify-content: center;

    .num {
      background: url('../../../../../static/img/trace/bg-num.png');
      width: 84px;
      height: 106px;
      line-height: 106px;
      text-align: center;
      margin-right: 16px;
    }
  }
}
</style>

<template>
  <div class="describe">
    <p class="title">可追溯商品总量</p>
    <div class="total-num">
      <div class="num" v-for="(item,index) in data" :key="index">{{item}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [3, 0, 0, 8, 2, 1],
      num: 0
    }
  },
  components: {
  },
  mounted() {
    const that = this;
    setInterval(function () {
      if (that.num % 3 === 1) {
        that.data = [3, 0, 0, 8, 2, 1]
      } else if (that.num % 3 === 2) {
        that.data = [3, 0, 0, 8, 5, 1]
      } else if (that.num % 3 === 0) {
        that.data = [3, 0, 0, 9, 0, 0]
      }
      that.num++
    }, 5000)
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?78344d2c